import React, { useEffect } from 'react'
import { Head, useForm } from '@inertiajs/inertia-react';
import Loading from '../../Components/Loading'
import axios from 'axios';
import { Inertia } from '@inertiajs/inertia';
import redelcomLogoImg from '../../../images/redelcom.png'
import { useUsersRegistrationContext } from '@/context/UsersRegistration';

const LoadingPayment = ({order, redelcomLogo, redelcomTransactionId, isMercadopago}) => {
    const { removeUsersRegistration } = useUsersRegistrationContext();
    console.log('redelcom id: ',redelcomTransactionId)
    console.log('order: ', order)
    const postData = redelcomTransactionId ?
    {
        order_id: order.id,
        order_uuid: order.uuid,
        redelcomTransactionId
    }
    :
    {
        order_id: order.id
    }

    //console.log('el maldito postData', postData)

    const {data, post} = useForm(postData)

    const handleSubmit = () => {
        if(redelcomTransactionId){
            post(route('point.validate', {order}), { replace: true })
        }else if(isMercadopago){
            Inertia.visit(route('order.show', {uuid: order.uuid}, { replace: true }))
        }else{
            post(route('order.captureDTE'), { replace: true })
        }
    }

    // const handleSubmit = async () => {
    //     const confirmExit = (event) => {
    //         const confirmationMessage = "Al cerrar esta ventana podrías perder tu compra, ¿Estás seguro?";
    //         (event || window.event).returnValue = confirmationMessage;
    //         return null;
    //     }

    //     window.addEventListener("beforeunload", confirmExit);
    //     try {
    //         const response = await axios.post(route('api.order.captureDTE'), data);
    //         window.removeEventListener("beforeunload", confirmExit);

    //         Inertia.visit(response.data.redirect_url);
    //     } catch (error) {
    //         window.removeEventListener("beforeunload", confirmExit);
    //         handleSubmit();
    //     }
    // }

    useEffect(() => {
        removeUsersRegistration();
        handleSubmit();
    },[])

    return (
        <div className="w-full h-screen flex items-center justify-center">
            <div>
                <div className='w-40 text-center mx-auto mb-20'>{redelcomLogo && <img className='w-full' src={redelcomLogoImg} />}</div>
                <Loading title={`Estamos procesando su pago...`} className="mb-4">
                    <svg className="w-12 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z" /></svg>
                </Loading>
                <p className="text-center text-xl font-bold">No cierres esta ventana, porque podrías perder tu compra.</p>
            </div>
        </div>
    )
}

export default LoadingPayment


